(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationDetailController', ValorisationDetailController);

    ValorisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function ValorisationDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.valorisation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:valorisationUpdate', function(event, result) {
            vm.valorisation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
